import React from 'react';
import type { HTMLMotionProps } from 'framer-motion';
import { AnimatePresence } from 'framer-motion';
import { FadeAnimation } from './FadeAnimation';

type FadeContainerProps = {
  children: React.ReactNode;
} & HTMLMotionProps<'div'>;

export const FadeContainer = ({ children, ...props }: FadeContainerProps) => {
  return (
    <AnimatePresence>
      <FadeAnimation {...props}>{children}</FadeAnimation>
    </AnimatePresence>
  );
};
